import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ErrorPage from "../../Components/ErrorPage/ErrorPage";
import Mailbox from "../../Components/Footer/Mailbox";
import BrandComponent from "../../Components/BrandComponent/BrandComponent";
import useDocumentTitle from "../../PageTitle";

const Error404 = () => {
  useDocumentTitle("Restaurant | Error404")
  return (
    <div>
      <Header />
      <ErrorPage />
      <BrandComponent />
      <Mailbox />
      <Footer />
    </div>
  );
};

export default Error404;
